import { render, staticRenderFns } from "./SubSymbol.vue?vue&type=template&id=4874897e"
import script from "./SubSymbol.vue?vue&type=script&lang=js"
export * from "./SubSymbol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports